import { createBrowserHistory } from 'history';
import _ from 'lodash';

export const history = createBrowserHistory({
  basename: process.env.PUBLIC_URL,
}); //https://github.com/ReactTraining/react-router/blob/master/FAQ.md#how-do-i-access-the-history-object-outside-of-components

//this method store SearchParam during redirect
export const redirect = (
  path: string,
  includeParams?: { [key: string]: string },
  excludeParams?: string[]
) => {
  const urlSearchParams = new URLSearchParams(history.location.search);
  for (const key in includeParams) {
    urlSearchParams.set(key, includeParams[key]);
  }
  _.forEach(excludeParams, p => urlSearchParams.delete(p));
  history.push(path + '?' + urlSearchParams);
};

export const getSearchParam = (key: string) => {
  const urlSearchParams = new URLSearchParams(history.location.search);
  return urlSearchParams.get(key);
};

export const setSearchParam = (params: { [key: string]: string }) => {
  redirect(history.location.pathname, params);
};
export const deleteSearchParam = (params: string[]) => {
  redirect(history.location.pathname, undefined, params);
};
